import Router from "next/router";
import { API_ERROR_CODES, DEFAULT_LOCALE } from "../constants";
import { getAccessToken } from "../services/auth";

type FetcherProps = {
    options?: any;
    accessToken?: string;
    locale?: string;
};

export async function fetcher(url: string, props?: FetcherProps) {
    const options = props?.options ?? {};
    let accessToken = props?.accessToken;
    const locale = props?.locale ?? Router.locale ?? DEFAULT_LOCALE;

    if (!accessToken) {
        const token = await getAccessToken();
        if (!token) {
            throw new Error(
                "No active account! Verify a user has been signed in and setActiveAccount has been called."
            );
        }
        accessToken = token;
    }
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);
    headers.append("Accept-Language", locale);

    const newOptions = {
        headers: headers,
        ...options,
    };

    const res = await fetch(url, newOptions);
    if (!res.ok) {
        try {
            throw await res.json();
        } catch (e) {
            throw e ?? { ErrorCode: API_ERROR_CODES.UNKNOWN };
        }
    }

    if (res.status === 204) return null;

    const contentType = res.headers.get("Content-Type");
    if (contentType?.startsWith("text")) return res.text();
    if (!contentType || contentType.includes("json")) return res.json();
    return res.blob();
}

export default fetcher;
